import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import { fetchOrder } from '~services/api.helpers';

import FeedbackModalWrapper from './components/FeedbackModalWrapper';
import FeedbackGrader from './components/FeedbackGrader';

import { submitFeedback } from './ducks';

import { Spinner, Gap, ChevronButton, OrderWindow } from '~ui-kit';

import { primaryColor, lighterBlue } from '~theme';

import headerIcon from '~images/order_feedback.svg';

const OrderFeedbackModal = () => {
  const [order, setOrder] = useState(null);
  const [grade, setGrade] = useState(null);
  const [message, setMessage] = useState('');
  const [showOrder, setShowOrder] = useState(false);

  const dispatch = useDispatch();

  const show = useSelector(state => state.modals.show);
  const orderId = useSelector(state => state.modals.orderId);
  const userData = useSelector(state => state.user.data);
  const firstName = userData.givenName || 'käyttäjä';

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchOrder(orderId);
      setOrder(res);
    };

    if (orderId && show) {
      fetchData();
    }

    // Reset state when hidden
    if (!show) {
      setOrder(null);
      setGrade(null);
      setMessage('');
    }
  }, [orderId, show]);

  const handleSubmit = () => {
    dispatch(
      submitFeedback({
        message,
        rating: grade,
        type: 'MESSAGE_NPS_FEEDBACK',
        orderId,
      })
    );
  };

  return (
    <FeedbackModalWrapper
      name="ORDER_FEEDBACK"
      title={`Hei ${firstName}, palautteesi avulla teemme parempaa palvelua`}
      confirmOnClick={handleSubmit}
      confirmDisabled={!grade}
      headerLargeIcon={headerIcon}
    >
      <Wrapper>
        <OrderDetails>
          {order ? (
            <div>
              <div>
                Tilaus: {order.categoryName}, tilaus no. #{order.id}
              </div>
              <Gap height="12px" />
              {showOrder && (
                <>
                  <OrderWindow order={order} />
                  <Gap height="12px" />
                </>
              )}
              <ShowDetails onClick={() => setShowOrder(!showOrder)}>
                <ChevronButton up={showOrder} />
                <ShowDetailsText>
                  {showOrder
                    ? 'Piilota tilauksen tiedot'
                    : 'Näytä tilauksen tiedot'}
                </ShowDetailsText>
              </ShowDetails>
            </div>
          ) : (
            <Spinner />
          )}
        </OrderDetails>
        <br />
        <br />

        <FeedbackQuery>
          Kerro meille kuinka todennäköisesti suosittelisit saamaasi palvelua?
        </FeedbackQuery>

        <br />

        <FeedbackGrader value={grade} setValue={setGrade} />

        <Gap height="24px" />

        <Label>Kommenttisi</Label>
        <TextArea
          className="form-control"
          maxLength="2000"
          rows={5}
          placeholder="Kerro halutessasi tarkempi kuvailu palvelukokemuksestasi"
          value={message}
          onChange={event => setMessage(event.target.value)}
        />
      </Wrapper>
    </FeedbackModalWrapper>
  );
};

const Wrapper = styled.div`
  color: ${primaryColor};
`;

const OrderDetails = styled.div`
  font-size: 16px;
`;

const FeedbackQuery = styled.div`
  font-size: 16px;
`;

const Label = styled.label`
  font-size: 16px;
  margin-bottom: 12px;
`;

const TextArea = styled.textarea`
  display: block;
  margin-bottom: 50px;
  resize: none;
`;

const ShowDetails = styled.div`
  display: flex;
  align-items: center;
  color: ${lighterBlue};
  cursor: pointer;
`;

const ShowDetailsText = styled.div`
  margin-left: 8px;
`;

export default OrderFeedbackModal;
